// extracted by mini-css-extract-plugin
export default {"r_l":"be34f115e4 acd6bf9a44","t":"f4bb9f305c"};